type EmojiProps = {
  label: string;
  symbol: string;
};

export const Emoji = ({ label, symbol }: EmojiProps) => (
  <span className="emoji" role="img" aria-label={label} aria-hidden="true">
    {symbol}
  </span>
);
